<template>
  <v-app-bar color="primary" app style="width: 100vw; z-index: 6;" flat>
    <v-btn color="white" icon @click="showDrawer" v-if="$vuetify.breakpoint.lgAndDown">
      <v-icon>mdi-menu</v-icon>
    </v-btn>

    <div class="d-flex gap-5 align-center white--text" style="gap: 10px; font-size: .8rem;" v-if="$vuetify.breakpoint.lgAndUp">
      MÓDULO  1 - LEGISLAÇÃO DE TRÂNSITO
    </div>

    <v-spacer />

    <AccessibilityButtons></AccessibilityButtons>

  </v-app-bar>
</template>

<script>
import AccessibilityButtons from "@/components/AccessibilityButtons.vue";

export default {
  components: {
    AccessibilityButtons,
  },

  data() {
    return {};
  },

  methods: {
    showDrawer() {
      this.$store.commit("TOGGLE_SHOW_MENU_DRAWER");
    },
  },
};
</script>

<style scoped></style>
